import { render, staticRenderFns } from "./BaseDisplayCkeditorContent.vue?vue&type=template&id=2f754dfc&"
import script from "./BaseDisplayCkeditorContent.vue?vue&type=script&lang=js&"
export * from "./BaseDisplayCkeditorContent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports